//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/** @jsxImportSource @emotion/react */

// NOTE: This file uses Emotion CSS and should be migrated to Tailwind CSS.
// Dark mode colors reference Carbon design tokens defined in tailwind.config.js:
// - #161616 (carbon.dark)
// - #262626 (carbon.darkPanel)
// - #3f3f4a (carbon border dark)
// - #c8c8dd (carbon text dark)

export const cardStyles = {
  cardContainer: (darkMode = false) => ({
    border: darkMode ? '1px solid #3f3f4a' : '1px solid #D3D3E5',
    borderRadius: '4px',
    marginBottom: '20px',
    marginLeft: '50px',
    boxShadow: '2px 4px 8px 0px #00000040',
    color: darkMode ? '#c8c8dd' : '#3F3F4A',
    backgroundColor: darkMode ? '#262626' : '#F5F5FBCC',
    transition: 'background-color 0.3s ease, border-color 0.3s ease',
    '@media (prefers-color-scheme: dark)': {
      border: '1px solid #3f3f4a',
      color: '#c8c8dd',
      backgroundColor: '#262626',
    },
  }),
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0px 8px 20px',
  },
  cardTitle: {
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: 600,
    padding: '0px 20px 0 20px',
  },
  AIcardTitle: {
    marginLeft: '15px',
    fontFamily: 'Roboto',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '20px',
    letterSpacing: '0px',
    verticalAlign: 'middle',
    color: '#000000',
  },
  AIcardDescription: {
    fontFamily: 'Roboto',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '24px',
    letterSpacing: '0%',
    color: '#1C262E',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  aiPromptsContainer: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    height: '100%',
  },
  cardIcons: {
    display: 'flex',
    gap: '15px',
  },
  cardDescription: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '24px',
    marginTop: '0px',
    marginLeft: '20px',
  },
  cardFooter: {
    width: '100%',
    height: '50px',
    borderRadius: '0px 0px 8px 8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: '1px solid #D3D9DE',
  },
  cardFooterContent: {
    marginLeft: '20px',
    display: 'flex',
    alignItems: 'center',
  },
  card: {
    border: '1px solid #C8C8DD',
    borderRadius: '4px',
    padding: ' 0px 10px',
    marginRight: '10px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  AI: {
    width: '100%',
    height: '24px',
    marginLeft: '10px',
    cursor: 'pointer',
    marginRight: '10px',
  },
  dropdownButton: {
    top: 'auto',
    bottom: '100%',
    left: 0,
    background: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    zIndex: 10,
    minWidth: '180px',
    borderRadius: '4px',
    padding: '8px 0',
  },
  buttonStyle: {
    padding: '8px 16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    width: '100%',
  },
  iconButtonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  iconButtonImage: {
    marginRight: '5px',
    height: '15px',
    width: '15px',
  },
  iconButton: {
    marginRight: '10px',
    backgroundColor: 'transparent',
    border: 'none',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    color: '#3F3F4A',
    cursor: 'pointer',
  },
  separator: {
    margin: '0 10px',
    color: '#C8C8DD',
  },
  dropdownMenu: {
    top: '30px',
    right: '0',
    backgroundColor: 'white',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    zIndex: 20,
  },
  dropdownItem: {
    padding: '10px 20px',
    cursor: 'pointer',
    backgroundColor: 'white',
    border: '1px solid transparent',
  },
  dropdownSeparator: {
    borderTop: '1px solid #ddd',
  },
  aiModuleOverlay: {
    display: 'flex',
    top: '60px',
    right: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1200,
  },
  aiModuleContainer: {
    width: '700px',
    height: '100%',
    backgroundColor: '#fff',
    boxShadow: '-2px 0 5px rgba(0, 0, 0, 0.1)',
    zIndex: 1201,
    display: 'flex',
    marginLeft: 'auto',
  },
  aiModuleHeader: {
    padding: '16px',
    borderBottom: '1px solid #ddd',
    display: 'flex',
    alignItems: 'center',
  },
  aiModuleBetaMessage: {
    fontSize: '12px',
    color: '#0066B0',
    fontStyle: 'italic',
    marginTop: '2px',
  },
  topRight: {
    background: 'none',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    marginLeft: 'auto',
  },
  closeButton: {
    background: 'none',
    marginTop: '10px',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    marginLeft: 'auto',
  },
  aiModuleContent: {
    padding: '16px',
  },
  icon: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
  },
  // Generic inline utilities moved from AIModule
  flexRowCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  headerTitleText: {
    marginRight: '8px',
    fontSize: '17px',
    fontWeight: 500,
    color: '#1C262E',
  },
  aiPersonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  aiPersonImage: {
    width: '150px',
    height: '150px',
    marginTop: '20px',
  },
  searchHitContainer: {
    marginTop: '10px',
  },
  searchResultTypography: {
    color: '#3D5466',
    fontSize: 14,
    fontFamily: 'Roboto',
  },
  searchResultDescription: {
    color: '#3D5466',
    fontSize: 14,
    fontFamily: 'Roboto',
    marginTop: '10px',
    marginBottom: '10px',
  },
  noSearchResults: {
    padding: '20px',
    textAlign: 'center' as const,
    color: '#666',
  },
  searchError: {
    padding: '20px',
    textAlign: 'center' as const,
    color: '#d32f2f',
  },
  chatHistoryUserContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '10px',
  },
  chatHistoryAiContainer: {
    marginBottom: '36px',
  },
  // New styles moved from inline CSS
  aiModuleOverlayFixed: {
    display: 'flex',
    top: '48px',
    right: '0',
    width: '100%',
    height: 'calc(100vh - 48px)',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1200,
    position: 'fixed' as const,
  },
  aiModuleContainerColumn: {
    width: '700px',
    height: '100%',
    backgroundColor: '#fff',
    boxShadow: '-2px 0 5px rgba(0, 0, 0, 0.1)',
    zIndex: 1201,
    display: 'flex',
    marginLeft: 'auto',
    flexDirection: 'column' as const,
    position: 'relative' as const,
  },
  aiModuleHeaderWithGap: {
    padding: '11px 20px 4px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: 'rgba(211, 217, 222, 0.2)',
  },
  aiModuleHeaderInner: {
    display: 'flex',
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
  },
  aiModuleContentScrollable: {
    padding: '16px',
    overflowY: 'auto' as const,
    flex: 1,
    scrollbarWidth: 'thin' as const,
    msOverflowStyle: 'none' as const,
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0, 0, 0, 0.2)',
      borderRadius: '3px',
    },
  },
  aiWelcomeContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  aiWelcomeImage: {
    width: '150px',
    height: '150px',
    marginTop: '20px',
  },
  aiPromptsContainerColumn: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    height: '100%',
    flexDirection: 'column' as const,
  },
  welcomeCard: {
    width: '530px',
    height: '80px',
    boxShadow: 'none',
    marginBottom: '14px',
  },
  welcomeCardText: {
    color: '#1C262E',
    fontSize: 18,
    textAlign: 'center' as const,
    verticalAlign: 'middle',
    fontWeight: 600,
  },
  topRightHeader: {
    background: 'none',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    marginLeft: 'auto',
    display: 'inline-flex',
    alignItems: 'center',
  },
  aiLogoImage: {
    width: '20px',
    height: '20px',
  },
  closeButtonImage: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
  },
  aiTitleContainer: {
    color: '#000000',
    margin: 0,
  },
  aiTitleWithLoop: {
    color: '#0066B0',
    margin: 0,
  },
  aiTitleLoopText: {
    marginLeft: '8px',
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '34px',
    letterSpacing: '0.16px',
    color: '#4A4A56',
    wordWrap: 'break-word' as const,
  },
  aiTitleLoopName: {
    color: '#0066B0',
    marginLeft: '8px',
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '34px',
    letterSpacing: '0.16px',
    wordWrap: 'break-word' as const,
  },
};

export const loopHomeStyles = {
  noTeamspaceViewOuter: {
    marginTop: '40px',
    transition: 'opacity 0.5s ease-in-out',
  },
  noTeamspaceMessage: {
    width: '359px',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontStyle: 'Medium',
    fontSize: '14px',
    lineHeight: '100%',
    letterSpacing: '0.2px',
    marginLeft: '50%',
    transform: 'translateX(-50%)',
  },
  teamspaceImage: {
    width: '140.87px',
    height: '140px',
    transform: 'rotate(0deg)',
    opacity: 1,
    display: 'block',
    margin: '0 auto',
  },
  createTeamspaceButton: {
    marginTop: '24px',
    backgroundColor: '#0066B0',
    color: 'white',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '16px',
    borderRadius: '4px',
    border: 'none',
    padding: '10px 32px',
    cursor: 'pointer',
  },
  searchInput: {
    width: '300px',
    padding: '9px 10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '16px',
    marginRight: '10px',
  },
  searchIcon: {
    marginRight: '30px',
    cursor: 'pointer',
  },
  addButton: {
    backgroundColor: '#0066B0',
    color: 'white',
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontStyle: 'Medium',
    fontSize: '14px',
    height: '36px',
    lineHeight: '100%',
    letterSpacing: '0px',
    borderRadius: '4px',
    border: 'none',
    padding: '6px 15px',
  },
  addButtonNoLoop: {
    backgroundColor: '#0066B0',
    color: 'white',
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '26px',
    borderRadius: '4px',
    border: 'none',
    padding: '6px 15px',
    '&:hover': {
      backgroundColor: '#032BA8',
    },
  },
  addButtonNoLoopDisabled: {
    backgroundColor: '#cccccc',
    color: 'white',
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '26px',
    borderRadius: '4px',
    border: 'none',
    padding: '6px 15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  message: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16.94px',
    letterSpacing: '0%',
    color: '#33333D',
  },
  filterButton: {
    flex: 0.7,
    display: 'flex',
    marginLeft: '50px',
    alignItems: 'flex-start',
  },
  filterContainer: {
    marginTop: '0px',
    marginLeft: '-28px',
  },
  filterButtonSelected: {
    selectedFilter: {
      color: '#0066b0',
      fontFamily: 'Inter',
      fontSize: '12px',
      fontWeight: 600,
      lineHeight: '14.52px',
      backgroundColor: 'transparent',
      borderRadius: '4px',
      border: 'none',
      padding: '6px',
      margin: '10px 0',
      cursor: 'pointer',
      marginLeft: '30px',
    },
    filter: {
      backgroundColor: 'transparent',
      color: '#33333D',
      fontFamily: 'Inter',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '14.52px',
      borderRadius: '4px',
      border: 'none',
      padding: '6px',
      margin: '10px 0',
      cursor: 'pointer',
      marginLeft: '30px',
    },
  },
  aiChatIcon: {
    bottom: '20px',
    right: '10px',
    width: '52px',
    height: '52px',
    cursor: 'pointer',
  },
  aiChatIconDisabled: {
    bottom: '20px',
    right: '10px',
    width: '52px',
    height: '52px',
  },
  noLoopUserText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontStyle: 'Medium',
    fontSize: '24px',
    lineHeight: '100%',
    letterSpacing: '0%',
    verticalAlign: 'middle',
    color: '#354958',
  },
  noLoopUserContainer: {
    border: '2px dashed #9DD1FF',
    borderRadius: '10px',
    padding: '30px',
    maxWidth: '600px',
    margin: '40px auto',
    backgroundColor: '#F9FBFF',
  },
};

export const modalStyles = {
  overlay: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'flex-end',
    zIndex: 1,
  },
  modal: {
    marginTop: '60px',
    width: '30%',
    height: '100%',
    backgroundColor: 'white',
    padding: '20px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  },
  closeButton: {
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
  },
  name: {
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '18px',
    letterSpacing: '0px',
    color: '#000000',
  },
  members: {
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '18px',
    letterSpacing: '0px',
    color: '#000000',
  },
  closeIcon: {
    cursor: 'pointer',
    width: '16px',
    height: '16px',
  },
  addMember: {
    gap: '5px',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0px',
    color: '#000000',
    marginRight: '20px',
    curson: 'pointer',
    marginLeft: 'auto',
    padding: '5px',
    borderRadius: '5px',
    displayFlex: 'flex',
    alignItems: 'center',
  },
  search: {
    width: '100%',
    height: '35px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px',
    paddingLeft: '30px',
    backgroundColor: '#F2F4F5',
  },
  memberlist: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0px',
    color: '#33333D',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    marginTop: '10px',
  },
  addButton: {
    height: '35px',
    width: '90px',
    borderRadius: '6px',
    border: '1px solid #C6C6C6',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0.16px',
    color: '#7A7A7A',
  },
  warningMessage: {
    fontSize: '12px',
    color: '#C10C0D',
    fontWeight: '400',
    fontStyle: 'italic',
    display: 'flex',
    padding: '10px',
  },
  editModalAddButtonMouseOver: {
    background: '#E9F2FF',
    transition: 'background-color 0.2s ease',
    cursor: 'pointer',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  },
  editModalAddButtonMouseOut: {
    background: 'white',
    transition: 'background-color 0.2s ease',
    boxshadow: 'none',
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '20px',
    paddingTop: '10px',
    flexShrink: 0,
  },
  saveButton: {
    backgroundColor: '#0066B0',
    color: '#FFFFFF',
    border: 'none',
  },
};

export const emailInputStyles = {
  container: {
    top: '30px',
    right: '0',
  },
  input: {
    padding: '5px',
    border: '1px solid #A8A8BD',
    borderRadius: '5px',
    marginRight: '5px',
  },
  button: {
    padding: '5px 10px',
    backgroundColor: '#000',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  warning: {
    color: 'red',
    fontSize: '12px',
    marginTop: '5px',
    marginLeft: '10px',
  },
};

export const selectedToolStyles = {
  container: {
    marginRight: 0,
    background: '#E3F2FD',
    borderRadius: 4,
    padding: '2px 6px',
    display: 'inline-flex',
    alignItems: 'center',
  },
  text: {
    fontWeight: 500,
  },
  removeButton: {
    marginLeft: 4,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: 12,
    color: '#1976d2',
  },
};

export const aiModuleStyles = {
  fixedContainer: {
    bottom: '0',
    right: '0',
    width: '700px',
    alignItems: 'left',
    padding: '10px',
    backgroundColor: '#fff',
  },
  fixedContainerWithPosition: {
    bottom: '0',
    right: '0',
    width: '700px',
    padding: '16px',
    backgroundColor: '#fff',
    position: 'fixed' as const,
    flexDirection: 'column' as const,
    borderTop: '1px solid #e5e7eb',
    overflow: 'visible',
    height: 'auto',
    display: 'flex',
  },
  promptText: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontStyle: 'italic',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#4a5568',
    marginBottom: '5px',
    padding: '0 8px',
    letterSpacing: '0.2px',
    marginLeft: '10px',
  },
  inputContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  inputContainerWithPosition: {
    display: 'flex',
    flexDirection: 'column' as const,
    width: '100%',
    alignItems: 'flex-start',
    position: 'relative' as const,
    padding: 0,
    background: 'transparent',
    borderRadius: '8px',
    boxShadow: 'none',
    overflow: 'hidden',
    flexShrink: 0,
    gap: '8px',
  },
  clearCommandSuggestion: {
    position: 'absolute' as const,
    bottom: '78px',
    left: '10px',
    backgroundColor: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
    padding: '8px',
    width: '270px',
  },
  clearCommandItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
  clearCommandItemHover: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
  },
  clearCommandText: {
    fontWeight: 'bold',
    color: '#0078d4',
    marginRight: '8px',
  },
  warningAI: {
    backgroundColor: '#fff3cd',
    color: '#856404',
    border: '1px solid #ffeeba',
    borderRadius: '4px',
    padding: '10px',
    fontSize: '14px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  micButton: (isListening: boolean) => ({
    backgroundColor: isListening ? 'rgba(255, 0, 0, 0.15)' : 'transparent',
    border: isListening ? '2px solid #ff0000' : 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition:
      'background-color 0.3s ease, border 0.3s ease, box-shadow 0.3s ease',
    boxShadow: isListening ? '0 0 8px rgba(255, 0, 0, 0.4)' : 'none',
  }),
  micButtonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  micButtonEnabled: {
    opacity: 1,
    cursor: 'pointer',
  },
  micIcon: (isListening: boolean) => ({
    width: '24px',
    height: '24px',
    filter: isListening ? 'drop-shadow(0 0 4px rgba(255, 0, 0, 0.6))' : 'none',
  }),
};

export const aiResponseStyles = {
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap' as const,
    overflow: 'visible',
    width: '100%',
  },
  containerWithFeedback: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'nowrap' as const,
    overflow: 'visible',
    width: '100%',
    position: 'relative' as const,
  },
  logo: {
    width: '30px',
    height: '30px',
    marginRight: '2px',
  },
  messageBox: {
    backgroundColor: '#f2f2f2',
    width: '100%',
    padding: '10px',
    borderRadius: '8px',
    margin: '5px 0',
    overflow: 'visible',
    whiteSpace: 'normal' as const,
    wordWrap: 'break-word' as const,
    wordBreak: 'break-word' as const,
    height: 'auto',
    display: 'flex',
    flexDirection: 'column' as const,
  },
  messageBoxExtended: {
    backgroundColor: '#F2F4F5',
    width: 'auto',
    padding: '10px 14px',
    borderRadius: '8px',
    flex: 1,
    textAlign: 'left' as const,
    overflow: 'visible',
    whiteSpace: 'normal' as const,
    wordWrap: 'break-word' as const,
    wordBreak: 'break-word' as const,
    // Left offset is 42px (logo 30 + marginRight 2 + bubble marginLeft 10), so
    // reserve exactly that much; the bubble's right edge then reaches the same
    // edge as the tool box and the user bubble.
    maxWidth: 'calc(100% - 42px)',
    minHeight: 'auto',
    height: 'auto',
    marginLeft: '10px',
  },
  logContainer: {
    boxShadow: 'none',
    backgroundColor: '#F8F9FA',
    border: '1px solid #E0E0E0',
    borderRadius: '8px !important',
    overflow: 'hidden',
    '&:before': { display: 'none' },
  },
  logSummary: {
    minHeight: '44px',
    padding: '0 16px',
    borderBottom: '1px solid #E0E0E0',
    '& .MuiAccordionSummary-content': { margin: '10px 0' },
  },
  logSummaryText: {
    fontSize: '14px',
    color: '#444',
    fontWeight: 600,
  },
  logDetails: {
    padding: '12px 16px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '8px',
    backgroundColor: '#fff',
  },
  logLine: {
    fontSize: '13px',
    color: '#1C262E',
    lineHeight: '1.5',
  },
  logLineStrong: {
    fontWeight: 600,
    marginRight: '5px',
  },
  logWrapperBox: {
    padding: 0,
    background: 'transparent',
    boxShadow: 'none',
    border: 'none',
    maxWidth: '100%',
  },
  messageText: {
    margin: 0,
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '24px',
    letterSpacing: '0%',
  },
  messageTextParagraph: {
    margin: '0 0 8px 0',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '1.5',
    letterSpacing: '0%',
    color: '#1C262E',
  },
  messageTextListItem: {
    marginBottom: '4px',
    lineHeight: '1.5',
    fontFamily: 'Roboto',
    fontSize: '13px',
    color: '#1C262E',
  },
  subMessageText: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0%',
    margin: 0,
    color: '#354958',
  },
  subMessageTextExtended: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0%',
    whiteSpace: 'normal' as const,
    wordWrap: 'break-word' as const,
    overflow: 'visible',
    maxWidth: '100%',
    margin: '8px 0 0 0',
    color: '#354958',
  },
  loopsContainer: {
    marginTop: '20px',
    display: 'flex',
    gap: '10px',
    padding: '10px',
  },
  loopsContainerExtended: {
    marginTop: '12px',
    display: 'flex',
    gap: '10px',
    padding: '10px',
    flexWrap: 'wrap' as const,
  },
  loopButton: {
    padding: '8px 12px',
    backgroundColor: '#FFFFFF',
    color: '#000000',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    boxShadow: '0px 4px 4px 0px #00000012',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0%',
  },
  loopButtonExtended: {
    padding: '8px 12px',
    backgroundColor: '#FFFFFF',
    color: '#000000',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    boxShadow: '0px 4px 4px 0px #00000012',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0%',
    textAlign: 'center' as const,
    margin: '4px 8px 4px 0',
  },
  feedbackContainer: {
    position: 'absolute' as const,
    bottom: '-24px',
    right: '0px',
    display: 'flex',
    gap: '2px',
    alignItems: 'center',
  },
  feedbackButton: {
    padding: '2px',
  },
  feedbackButtonActive: {
    up: 'rgba(0,0,0,0.7)',
    down: 'rgba(0,0,0,0.7)',
    default: 'rgba(0,0,0,0.35)',
  },
  codeBlock: {
    background: '#fff',
    color: '#1f1f1f',
    fontSize: '1em',
    borderRadius: '6px',
    padding: '1em',
    margin: '1em 0',
    overflowX: 'auto' as const,
  },
  inlineCode: {
    background: '#fff',
    color: '#c7254e',
    fontSize: '0.95em',
    borderRadius: '4px',
    padding: '0.2em 0.4em',
    fontFamily: 'monospace',
  },
  link: {
    color: '#007bff',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse' as const,
    margin: '1em 0',
  },
  tableHeader: {
    background: '#f0f0f0',
    fontWeight: 'bold' as const,
    border: '1px solid #ddd',
    padding: '0.5em',
  },
  tableCell: {
    border: '1px solid #ddd',
    padding: '0.5em',
  },
  blockquote: {
    borderLeft: '4px solid #6bf5faff',
    margin: '1em 0',
    padding: '0.5em 1em',
    background: '#f8f8f8',
    color: '#354958',
    fontStyle: 'italic',
  },
  strong: { fontWeight: 700, color: '#000' },
  em: { fontStyle: 'italic', color: '#354958' },
  del: { textDecoration: 'line-through', color: '#d32f2f' },
};

export const userResponseStyles = {
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    margin: '6px 0 32px 0',
  },
  message: {
    backgroundColor: '#5C6FCB',
    color: '#fff',
    padding: '10px 14px',
    borderRadius: '12px',
    fontSize: '13px',
    fontWeight: 400,
    fontFamily: 'Roboto',
    lineHeight: '1.5',
    margin: 0,
    maxWidth: '75%',
    wordBreak: 'break-word' as const,
    whiteSpace: 'pre-wrap' as const,
    overflowWrap: 'anywhere' as const,
    display: 'block',
    overflowY: 'auto' as const,
    maxHeight: '320px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
    scrollbarWidth: 'thin' as const,
    '&::-webkit-scrollbar': { width: '8px' },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(255,255,255,0.25)',
      borderRadius: '12px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0,0,0,0.25)',
      borderRadius: '12px',
    },
  },
  htmlMessage: {
    margin: 0,
    whiteSpace: 'pre-wrap' as const,
    wordBreak: 'break-word' as const,
    overflowWrap: 'anywhere' as const,
  },
  plainMessage: {
    margin: 0,
    whiteSpace: 'pre-wrap' as const,
    wordBreak: 'break-word' as const,
    overflowWrap: 'anywhere' as const,
    display: 'block',
  },
  copyButtonWrapper: {
    position: 'relative' as const,
    maxWidth: '75%',
  },
};

export const aiIconStyles = {
  container: {
    position: 'relative' as const,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  glow: {
    position: 'absolute' as const,
    inset: 0,
    borderRadius: '50%',
    backgroundColor: 'rgba(25, 118, 210, 0.4)',
    filter: 'blur(8px)',
    animation: 'aiIconBreathe 2s ease-in-out infinite',
    opacity: 0,
  },
  ring: {
    position: 'absolute' as const,
    inset: '-4px',
    borderRadius: '50%',
    border: '2px solid rgba(25, 118, 210, 0.3)',
    animation: 'aiIconBreathe 2s ease-in-out infinite 0.5s',
    opacity: 0,
  },
  image: {
    position: 'relative' as const,
    animation: 'aiIconScale 2s ease-in-out infinite',
    filter: 'drop-shadow(0 0 8px rgba(25, 118, 210, 0.5))',
  },
  shimmer: {
    position: 'absolute' as const,
    inset: 0,
    borderRadius: '50%',
    background:
      'linear-gradient(135deg, rgba(255,255,255,0.6) 0%, transparent 50%, rgba(255,255,255,0.6) 100%)',
    animation:
      'aiIconRotate 3s linear infinite, aiIconFade 2s ease-in-out infinite',
    opacity: 0,
    pointerEvents: 'none' as const,
  },
};

export const textInput = {
  '& .MuiOutlinedInput-input': {
    padding: '8px 12px',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
  },
  '& textarea': {
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
  },
  '& textarea::placeholder': {
    color: '#3D5466',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'italic',
  },
  flex: 1,
  padding: '8px 12px',
  border: '1px solid transparent',
  borderRadius: '20px 20px 20px 20px',
  borderRight: 'none',
  marginLeft: '0px',
  marginRight: '0px',
  minHeight: '44px',
  maxHeight: '150px',
  color: '#12191F',
  fontSize: '14px',
  fontFamily: 'Roboto',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.05)',
  transition: 'all 0.3s ease',
  resize: 'none' as const,
  overflowY: 'auto' as const,
  overflowX: 'hidden' as const,
  whiteSpace: 'pre-wrap' as const,
  wordBreak: 'break-word' as const,
  scrollbarWidth: 'none' as const,
  msOverflowStyle: 'none' as const,

  '&:focus': {
    boxShadow: 'inset 0 1px 3px rgba(25, 118, 210, 0.2)',
    backgroundColor: 'white',
  },
};
